export default __webpack_public_path__ + "static/media/drink-vend.d3a45c00.jpg";